import { TitleProps } from "./TitleProps";

const Title: React.FC<TitleProps> = ({
    text
}) => {
    return (
        <h1 className="w-full mb-6 leading-normal text-center" data-aos="fade-left" data-aos-delay="300"><span className="relative inline-block px-2 mx-2 before:block before:absolute before:-inset-1 before:-skew-y-6 before:bg-sky-50 dark:before:bg-sky-500/20 before:rounded-md before:backdrop-blur-xl"><span className="relative text-custom-500">{text}</span></span></h1>
    )
}

export default Title;